// extracted by mini-css-extract-plugin
export default {"footerContainer":"footerPage_footerContainer__2jzOz","buttonsContainer":"footerPage_buttonsContainer__OT3Gd","findButton":"footerPage_findButton__4XEpw"};